const LinksHeader: React.FC<React.PropsWithChildren> = ({ children }) => (
  <h2 className="mb-2.5 font-serif text-xl font-bold text-blue900">
    {children}
  </h2>
);

const LinksList: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ul className="flex flex-col gap-1 pl-2.5">{children}</ul>
);

const LinksLink: React.FC<React.PropsWithChildren<{ href: string }>> = ({
  children,
  href,
}) => (
  <a
    href={href}
    className={`${["/categories", "/brands"].includes(href) ? "text-blue450" : "text-black100"} hover:text-blue`}
  >
    {children}
  </a>
);

export const LinksNav: React.FC<{
  header: string;
  links: { href: string; text: string }[];
}> = ({ header, links }) => (
  <nav aria-label={`${header} nav`}>
    <LinksHeader>{header}</LinksHeader>
    <LinksList>
      {links.map(({ href, text }) => (
        <li key={href}>
          <LinksLink href={href}>{text}</LinksLink>
        </li>
      ))}
    </LinksList>
  </nav>
);

const Links: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="flex w-full flex-col justify-between gap-y-5 text-center md:mx-auto md:max-w-[764px] md:flex-row md:gap-y-0 md:text-left lg:mx-0 lg:w-[calc(75%-5rem)] lg:max-w-none">
    {children}
  </div>
);

export default Links;
